
import datetime from "./datetime";
import { formatMyr } from "./money";

class Helper {
    constructor() {

    }

    // New code: `RM ${formatMyr(value)}` from utils/money.js. Kept for existing callers; the
    // currency defaults to MYR (never USD) and the locale is fixed to en-MY.
    formatCurrency(currency, amount) {
      const cur = typeof currency === "string" && currency.length === 3 ? currency : "MYR";
      try {
        return new Intl.NumberFormat("en-MY", {
          style: "currency",
          currency: cur,
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }).format(parseFloat(amount) || 0);
      } catch (error) {
        console.error("Currency formatting error:", error);
        return "RM " + formatMyr(amount);
      }
    }

    isPdf(document) {
      try {
        if (document.contentType == "application/pdf") return true;
        return false;
      } catch (error) {
        return false;
      }
    }

    getDocumentUrl(document) {
      try {
        return apiUrl + "documents/file/" + document.id;
      } catch (error) {
        return "";
      }
    }
    
    // Quotation-style statuses only (Draft / Sent / Accepted / Rejected / Cancelled), colours per
    // UI-GUIDELINES section 3.3. New code should use utils/statusBadges.js, not this helper.
    getBadgeClass(statusDescription) {
        const colors = {
          Draft: "secondary",
          Sent: "info",
          Accepted: "success",
          Rejected: "danger",
          Cancelled: "secondary",
        };
        return "badge badge-" + (colors[statusDescription] || "secondary") + " ml-1";
      }

    getDisplayDate(dt) {
        return datetime.formatDate(dt);
    }

    getDisplayDateTime(dt) {
        return datetime.formatDateTime(dt);
    }

    /** Identity-validate a "yyyy-MM-dd" coming from <input type="date"> — DO NOT use new Date(). */
    parseDateInput(value) {
        return datetime.parseDateInput(value);
    }

    toApiDate(value) {
        return datetime.toApiDate(value);
    }

    toApiInstant(value) {
        return datetime.toApiInstant(value);
    }

    mytToday() {
        return datetime.mytToday();
    }

    removeObjFromArray(array, obj) {
        let loc = this.getArrayIndexByValue(array, obj);
        array.splice(loc, 1);
    }

    getArrayIndexByValue(arr, value) {
        for (var i = 0, iLen = arr.length; i < iLen; i++) {
            if (arr[i].id == value) return i;
        }
    }

    getErrorMessage2(data){
        try {
            return data.data;
        } catch (error) {
            return "Unknown error";
        }
    }
   

    isInt(n) {
        return Number(n) === n && n % 1 === 0;
    }

    isFloat(n) {
        return Number(n) === n && n % 1 !== 0;
    }

    isIntOrFloat(n) {
        if (this.isInt(n) || this.isFloat(n))
            return true;
        else
            return false;
    }

    hexToRgbA(hex, opacity) {
        var c;
        if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
            c = hex.substring(1).split('');
            if (c.length == 3) {
                c = [c[0], c[0], c[1], c[1], c[2], c[2]];
            }
            c = '0x' + c.join('');
            return 'rgb(' + [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(',') + ',' + Math.round((opacity / 100) * 10) / 10 + ')';
        }
        throw new Error('Bad Hex');
    }

    // Turns whatever lib/api.js rejects with into a readable sentence. `data` may be a string,
    // an AutoWrapper envelope ({ message, responseException: { exceptionMessage } }), an ASP.NET
    // validation problem ({ title, errors: { Field: ["msg"] } }), or undefined.
    getErrorMessage(data, fallback = "Something went wrong. Please try again.") {
      if (data === null || data === undefined || data === "") return fallback;
      if (typeof data === "string") return data;

      const exception = data.responseException ? data.responseException.exceptionMessage : null;
      const source = exception !== null && exception !== undefined ? exception : data;
      if (typeof source === "string" && source) return source;

      if (source && source.errors && typeof source.errors === "object") {
        const messages = Object.values(source.errors)
          .reduce((all, value) => all.concat(value), [])
          .filter((m) => typeof m === "string" && m);
        if (messages.length) return messages.join(" ");
      }
      if (source && typeof source.title === "string" && source.title) return source.title;
      if (source && typeof source.message === "string" && source.message) return source.message;
      if (typeof data.message === "string" && data.message) return data.message;
      return fallback;
    }


}

export default Helper;